/* Cozy Crest Co — theme interactions */
(function () {
  "use strict";

  /* ---------- Sticky header shadow ---------- */
  const header = document.querySelector(".site-header");
  if (header) {
    const onScroll = () => header.classList.toggle("is-scrolled", window.scrollY > 12);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Scroll reveal ---------- */
  const reveals = document.querySelectorAll("[data-reveal]");
  if ("IntersectionObserver" in window && reveals.length) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add("is-visible"));
  }

  /* ---------- Mobile navigation ---------- */
  const navToggle = document.querySelector("[data-nav-toggle]");
  const mobileNav = document.querySelector("[data-mobile-nav]");
  const overlay = document.querySelector("[data-mobile-overlay]");
  const navClose = document.querySelector("[data-nav-close]");
  const setNav = (open) => {
    if (!mobileNav) return;
    mobileNav.classList.toggle("is-open", open);
    if (overlay) overlay.classList.toggle("is-open", open);
    document.body.style.overflow = open ? "hidden" : "";
  };
  navToggle && navToggle.addEventListener("click", () => setNav(true));
  navClose && navClose.addEventListener("click", () => setNav(false));
  overlay && overlay.addEventListener("click", () => setNav(false));

  /* ---------- Accordions ---------- */
  document.querySelectorAll(".accordion__head").forEach((head) => {
    head.addEventListener("click", () => {
      const body = head.nextElementSibling;
      const open = body.style.maxHeight && body.style.maxHeight !== "0px";
      document.querySelectorAll(".accordion__body").forEach((b) => (b.style.maxHeight = "0px"));
      if (!open) body.style.maxHeight = body.scrollHeight + "px";
    });
  });

  /* ---------- Product gallery thumbs ---------- */
  const mainImg = document.querySelector("[data-main-img]");
  if (mainImg) {
    document.querySelectorAll("[data-thumb]").forEach((t) => {
      t.addEventListener("click", () => {
        mainImg.src = t.dataset.full || t.src;
      });
    });
  }

  /* ---------- Variant selection ----------
     The pills are the only control the customer sees, so they have to drive
     the real <select name="id"> that the form submits. Without this the form
     always posts the first variant no matter which pill looks selected. */
  (function variantSelector() {
    const form = document.getElementById("product-form");
    const dataEl = document.querySelector("[data-variant-json]");
    const groups = Array.from(document.querySelectorAll("[data-variant-group]"));

    if (!form || !dataEl) return;

    let variants = [];
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return; // leave the server-rendered state alone rather than break the page
    }
    if (!Array.isArray(variants) || !variants.length) return;

    const select = form.querySelector("[data-variant-select]");
    const priceEl = document.querySelector("[data-product-price]");
    const compareEl = document.querySelector("[data-product-compare]");
    const addBtn = form.querySelector("[data-add-btn]");

    // Read the selected value per option position, not per DOM order.
    function selectedOptions() {
      const opts = [];
      groups.forEach((g) => {
        const pos = parseInt(g.dataset.optionPosition || "0", 10) - 1;
        const active = g.querySelector(".variant-pill.is-active");
        if (pos >= 0) opts[pos] = active ? active.dataset.value : null;
      });
      return opts;
    }

    function findVariant(opts) {
      const matches = variants.filter((v) =>
        opts.every((o, i) => o == null || v.options[i] === o)
      );
      if (!matches.length) return null;
      return matches.find((v) => v.available) || matches[0];
    }

    function apply() {
      const v = findVariant(selectedOptions());

      if (!v) {
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = "Unavailable";
        }
        return;
      }

      if (select) select.value = String(v.id);
      if (priceEl) priceEl.innerHTML = v.price;
      if (compareEl) {
        compareEl.innerHTML = v.compare_at || "";
        compareEl.style.display = v.compare_at ? "" : "none";
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? "Add to cart" : "Sold out";
      }
    }

    groups.forEach((group) => {
      const pills = Array.from(group.querySelectorAll(".variant-pill"));
      const choose = (pill) => {
        pills.forEach((p) => {
          p.classList.toggle("is-active", p === pill);
          p.setAttribute("aria-pressed", p === pill ? "true" : "false");
        });
        apply();
      };
      pills.forEach((pill) => {
        pill.addEventListener("click", () => choose(pill));
        pill.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
            e.preventDefault();
            choose(pill);
          }
        });
      });
    });

    /* ---------- Default selection ----------
       Prefer the first variant that is actually in stock over whatever happens
       to be first in the list. Several products have a dead first variant, and
       defaulting to it loads an in-stock product showing "Sold out". */
    const preferred = variants.find((v) => v.available) || variants[0];

    function snapTo(variant) {
      groups.forEach((group) => {
        const pos = parseInt(group.dataset.optionPosition || "0", 10) - 1;
        const want = pos >= 0 ? variant.options[pos] : null;
        const pills = Array.from(group.querySelectorAll(".variant-pill"));
        let matched = false;
        pills.forEach((p) => {
          const on = p.dataset.value === want;
          if (on) matched = true;
          p.classList.toggle("is-active", on);
          p.setAttribute("aria-pressed", on ? "true" : "false");
        });
        if (!matched && pills.length) pills[0].classList.add("is-active");
      });
    }

    // Fill in any group the server left with nothing selected.
    groups.forEach((group) => {
      if (group.querySelector(".variant-pill.is-active")) return;
      const pills = Array.from(group.querySelectorAll(".variant-pill"));
      if (!pills.length) return;
      const pos = parseInt(group.dataset.optionPosition || "0", 10) - 1;
      const want = pos >= 0 && preferred ? preferred.options[pos] : null;
      const match = pills.find((p) => p.dataset.value === want) || pills[0];
      match.classList.add("is-active");
      match.setAttribute("aria-pressed", "true");
    });

    // If the resulting combination is out of stock while the product has stock
    // elsewhere, move the whole selection onto the first available variant.
    const initial = findVariant(selectedOptions());
    if (preferred && preferred.available && (!initial || !initial.available)) {
      snapTo(preferred);
    }

    apply();
  })();

  /* ---------- Quantity stepper ---------- */
  document.querySelectorAll(".qty").forEach((q) => {
    const input = q.querySelector("input");
    q.querySelector("[data-qty-minus]").addEventListener("click", () => {
      input.value = Math.max(1, parseInt(input.value || "1", 10) - 1);
    });
    q.querySelector("[data-qty-plus]").addEventListener("click", () => {
      input.value = parseInt(input.value || "1", 10) + 1;
    });
  });

  /* ---------- AJAX add to cart + count refresh ---------- */
  const updateCartCount = (count) => {
    document.querySelectorAll("[data-cart-count]").forEach((el) => {
      el.textContent = count;
      el.style.display = count > 0 ? "inline-flex" : "none";
    });
  };

  async function refreshCount() {
    try {
      const res = await fetch("/cart.js");
      const cart = await res.json();
      updateCartCount(cart.item_count);
    } catch (e) {
      /* storefront not live yet — ignore */
    }
  }

  document.querySelectorAll("form[action^='/cart/add']").forEach((form) => {
    form.addEventListener("submit", async (e) => {
      // Only intercept when Shopify AJAX is available.
      if (!window.fetch) return;
      e.preventDefault();
      const btn = form.querySelector("[type=submit]");
      const label = btn ? btn.textContent : "";
      if (btn) { btn.disabled = true; btn.textContent = "Adding…"; }
      try {
        const res = await fetch("/cart/add.js", { method: "POST", body: new FormData(form), headers: { Accept: "application/json" } });
        if (!res.ok) throw new Error("add failed");
        await refreshCount();
        if (btn) btn.textContent = "Added ✓";
        setTimeout(() => { if (btn) { btn.textContent = label; btn.disabled = false; } }, 1400);
      } catch (err) {
        // Fallback to native submit (e.g. in theme preview without JS cart)
        form.submit();
      }
    });
  });

  refreshCount();
})();
